import { render, staticRenderFns } from "./ArrowRightIcon.vue?vue&type=template&id=45d64d28&scoped=true&"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowRightIcon.vue?vue&type=style&index=0&id=45d64d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d64d28",
  null
  
)

export default component.exports